import { ChangeDetectionStrategy, Component, ElementRef, inject, input, output } from '@angular/core';
import { ActivityItem, ActivityItemClick } from '../../planning.types';

@Component({
  selector: 'app-activity-block',
  standalone: true,
  templateUrl: './activity-block.component.html',
  styleUrls: ['./activity-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityBlockComponent {
  readonly item   = input.required<ActivityItem>();
  readonly active = input<boolean>(false);

  readonly blockClick = output<ActivityItemClick>();

  private readonly el = inject(ElementRef<HTMLElement>);

  /** Transmet le bloc lui-même comme ancre de la fiche de détail. */
  protected emitClick(event: Event): void {
    event.preventDefault();
    const anchor = (this.el.nativeElement as HTMLElement).firstElementChild as HTMLElement;
    this.blockClick.emit({ id: this.item().id, anchor });
  }

  /** Date au format jj/mm pour la bulle de survol. */
  protected shortDate(): string {
    const [, month, day] = this.item().date.split('-');
    return day && month ? `${day}/${month}` : this.item().date;
  }
}
